import React, { useState, useEffect } from 'react'
import { Steps, Space} from 'antd'
import { useJKspListQuery } from '../../store/DianShangYeWuApi';
import LoanNodeCheckApprove from './LoanNodeCheckApprove';
import LoanNodeCheckEdit from './LoanNodeCheckEdit';
function LoanNodeCheck(props) {
    const [items, setItems] = useState([])
    const {data, isSuccess} = useJKspListQuery({jk_sp_jk_id:props.jk_id},{skip:!props.jk_id})
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 然后 map，判断是否是最后一个元素
            const newArr =  data.Result.map(item => {
                const {
                    jk_sp_jd_name,
                    jk_sp_yh_name,
                    jk_sp_yh_id,
                    jk_sp_jd_xuhao,
                    jk_sp_content,
                    jk_sp_id,
                    jk_sp_dsbzd_id,
                    jk_sp_dsbzd_name,
                    jk_sp_state,
                    jk_sp_state_time,
                    jk_sp_uname,
                    jk_sp_ctime,
                    jk_sp_dsbzd_date,
                    jk_sp_dsbzd_date_end,
                    jk_sp_dsbzd_kh_id,
                    jk_sp_dsbzd_kh_name,
                } = item;
                return {
                    jk_sp_jd_name,
                    jk_sp_yh_name,
                    jk_sp_yh_id,
                    jk_sp_jd_xuhao,
                    jk_sp_content,
                    jk_sp_id,
                    jk_sp_dsbzd_id,
                    jk_sp_dsbzd_name,
                    jk_sp_state,
                    jk_sp_state_time,
                    jk_sp_uname,
                    jk_sp_ctime,
                    jk_sp_dsbzd_date,
                    jk_sp_dsbzd_date_end,
                    jk_sp_dsbzd_kh_id,
                    jk_sp_dsbzd_kh_name,
                }                
            })
            // 排序数据
            const sortedData = newArr.sort((a, b) => {
                return a.jk_sp_jd_xuhao - b.jk_sp_jd_xuhao;
            });
            // 生成 arr 并计算 current
            let firstApproveWithState2Index = -1; // 在 arr 中的索引（状态为 '2' 的审批点）
            let lastItemIndex = -1; // 在 arr 中的最后一个 item 的索引
            let arrIndex = 0; // arr 的当前索引
            
            const arr = sortedData.map((item) => {
                let result = null;
                if(item.jk_sp_jd_name === '审批' && item.jk_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:<span style={{fontSize:"12px"}}>{item.jk_sp_yh_name}</span>,
                        jk_sp_state:item.jk_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.jk_sp_jd_name === '审批' && item.jk_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.jk_sp_yh_id ? <LoanNodeCheckApprove 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        jk_id={props.jk_id}
                                                                        jk_date={props.jk_date}
                                                                        jk_kh_id={props.jk_kh_id}
                                                                        jk_kh_name={props.jk_kh_name}
                                                                        jk_sp_id={item.jk_sp_id}
                                                                        jk_sp_jd_xuhao={item.jk_sp_jd_xuhao}
                                                                        jk_sp_jd_name={item.jk_sp_jd_name}
                                                                        jk_sp_yh_id={item.jk_sp_yh_id}
                                                                        jk_sp_yh_name={item.jk_sp_yh_name}
                                                                        jk_sp_uid={item.jk_sp_uid}
                                                                        jk_sp_uname={item.jk_sp_uname}
                                                                    /> : <span style={{fontSize:"12px"}}>{item.jk_sp_yh_name}</span>,
                        jk_sp_state:item.jk_sp_state,
                                                                    
                    }
                    // 找到第一个状态为 '2' 的审批点
                    if(firstApproveWithState2Index === -1){
                        firstApproveWithState2Index = arrIndex;
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.jk_sp_jd_name === '审批' && (item.jk_sp_state==='3' || item.jk_sp_state==='4' || item.jk_sp_state==='5')){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>审批</span>,
                        content:props.yh_id===item.jk_sp_yh_id ? <LoanNodeCheckEdit 
                                                                        sortedData={sortedData}
                                                                        yh_id={props.yh_id} 
                                                                        yh_name={props.yh_name} 
                                                                        jk_id={props.jk_id}
                                                                        jk_date={props.jk_date}
                                                                        jk_kh_id={props.jk_kh_id}
                                                                        jk_kh_name={props.jk_kh_name}
                                                                        jk_sp_id={item.jk_sp_id}
                                                                        jk_sp_jd_xuhao={item.jk_sp_jd_xuhao}
                                                                        jk_sp_jd_name={item.jk_sp_jd_name}
                                                                        jk_sp_yh_id={item.jk_sp_yh_id}
                                                                        jk_sp_yh_name={item.jk_sp_yh_name}
                                                                        jk_sp_uid={item.jk_sp_uid}
                                                                        jk_sp_uname={item.jk_sp_uname}
                                                                        jk_sp_state={item.jk_sp_state}
                                                                        jk_sp_state_time={item.jk_sp_state_time}
                                                                        jk_sp_content={item.jk_sp_content}
                                                                    />: <Space orientation='vertical' size={0}>
                                                                            <span style={{color:item.jk_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                                                                                {item.jk_sp_state==='4' ? '驳回' : '同意'}
                                                                                {item.jk_sp_content? '：'+item.jk_sp_content :''}
                                                                            </span>
                                                                            <span>{item.jk_sp_yh_name} {item.jk_sp_state_time} </span>
                                                                        </Space>,
                                                                        jk_sp_state:item.jk_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.jk_sp_jd_name === '抄送' && item.jk_sp_state==='1'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.jk_sp_yh_name}</span>,
                        jk_sp_state:item.jk_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.jk_sp_jd_name === '抄送' && item.jk_sp_state==='2'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.jk_sp_yh_name}</span>,
                        jk_sp_state:item.jk_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                else if(item.jk_sp_jd_name === '抄送' && item.jk_sp_state==='3'){
                    result = {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>抄送</span>,
                        content:<span style={{fontSize:"12px"}}>{item.jk_sp_yh_name} {item.jk_sp_state_time}</span>,
                        jk_sp_state:item.jk_sp_state,
                    }
                    lastItemIndex = arrIndex;
                    arrIndex++;
                }
                return result;
            })
            
            // 计算 current，规则优先级：'2' > '4' > 最后一个
            let calculatedCurrent = 0;
            let firstApproveWithState4Index = -1;

            // 查找 '2' 和 '4' 的索引
            arr.forEach((item, idx) => {
                if (item && item.jk_sp_state === '2' && firstApproveWithState2Index === -1) {
                    firstApproveWithState2Index = idx;
                }
                if (item && item.jk_sp_state === '4' && firstApproveWithState4Index === -1) {
                    firstApproveWithState4Index = idx;
                }
            });

            if (firstApproveWithState2Index !== -1) {
                calculatedCurrent = firstApproveWithState2Index;
            } else if (firstApproveWithState4Index !== -1) {
                calculatedCurrent = firstApproveWithState4Index;
            } else if (lastItemIndex !== -1) {
                calculatedCurrent = lastItemIndex;
            }

            // current 需要加上前面的"创建"和"提交"两个步骤
            setCurrent(calculatedCurrent + 2);
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"14px"}}>{props.jk_uname} {props.jk_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"14px"}}>{props.jk_uname} {props.jk_state_time}</span>,
            },...arr]);
        }else{
            setItems([]);
        }
        
        
    },[data, isSuccess,props.jk_id,props.jk_uname,props.jk_ctime,props.jk_state_time,props.jk_date,props.jk_kh_id,props.jk_kh_name,props.yh_id,props.yh_name])
    return (
        <Steps 
            items={items} 
            current={current} 
            size="small" 
            titlePlacement="vertical" 
        />
    )
}

export default LoanNodeCheck